import { prescriptionTranslationKeys } from '../../../../../translations';
import { StyledPrescriptionTextView } from '../../prescriptionTextView.styled';

type ExtendedDosagePackagesCountTextValueProps = {
   readonly packagesCount: number | undefined;
};

export const ExtendedDosagePackagesCountTextValue = (props: ExtendedDosagePackagesCountTextValueProps): JSX.Element => {
   return (
      <StyledPrescriptionTextView
         testId={'extendedDosagePackagesCount'}
         compact
         label={prescriptionTranslationKeys.quantity.quantity}
      >
         {props.packagesCount ?? '-'}
      </StyledPrescriptionTextView>
   );
};
